import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { SharedPipesModule } from '@bp/shared/pipes';

import { YoutubePlayerComponent, YoutubePlayerDialogComponent } from './components';
import { CustomThumbnailDirective, OpenYoutubePlayerDialogOnClickDirective } from './directives';

@NgModule({
	imports: [
		CommonModule,
		MatDialogModule,
		MatProgressBarModule,

		SharedPipesModule,
	],
	declarations: [
		YoutubePlayerComponent,
		YoutubePlayerDialogComponent,
		OpenYoutubePlayerDialogOnClickDirective,
		CustomThumbnailDirective,
	],
	exports: [
		YoutubePlayerComponent,
		OpenYoutubePlayerDialogOnClickDirective,
		CustomThumbnailDirective,
	],
})
export class SharedFeaturesYoutubePlayerModule {
}
